import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "environments/environment";
import { ProdFormulaModel } from "../models";

@Injectable({ providedIn: 'root' })
export class ProdFormulaModelService {
    constructor(private _http: HttpClient) { }

    /**
     * Gets all prodFormulaModel (model & types)
     * @returns 
     */
    getAll() {
        return this._http.get<ProdFormulaModel[]>(`${environment.rydApiUrl}/api/prod-formula-model`);
    }


    /**
     * Gets all formula's models
     * @returns prodFormulaModel list
     */
    getAllModels() {
        return this._http.get<ProdFormulaModel[]>(`${environment.rydApiUrl}/api/prod-formula-model/${true}`);
    }


    /**
    * Gets all formula's types
    * @returns prodFormulaModel list
    */
    getAllTypes() {
        return this._http.get<ProdFormulaModel[]>(`${environment.rydApiUrl}/api/prod-formula-model/${false}`);
    }
}
